module.exports = __webpack_public_path__ + "img/device_1002_1.82584cc3.svg";